import { useModalStyles } from "@saleor/autobooking/styles/modalStyles";
import AutoBookingConfig from "@saleor/autobooking/utils/objects";
import { AutoBookingErrorFragment } from "@saleor/fragments/types/AutoBookingErrorFragment";
import { CourierFilter } from "@saleor/types/globalTypes";
import React from "react";

import ExpressFleetSwitch from "../ExpressFleetSwitch";
import StatusMinutesField from "./StatusMinutesField";

export interface AutoBookingDialogFormProps {
  courierChoices: Array<{
    label: string;
    value: CourierFilter;
  }>;
  enabled: boolean;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  config: AutoBookingConfig;
  setConfig: React.Dispatch<React.SetStateAction<AutoBookingConfig>>;
  storeType: string;
  disabledField: boolean;
  errors: AutoBookingErrorFragment[];
  resetFormErrors: (field?: string) => void;
}

const AutoBookingDialogForm: React.FC<AutoBookingDialogFormProps> = props => {
  const {
    courierChoices,
    enabled,
    setEnabled,
    config,
    setConfig,
    disabledField,
    errors,
    resetFormErrors
  } = props;

  const classes = useModalStyles(props);

  return (
    <>
      <div className={classes.switchContainer}>
        <h4 className={classes.switchLabel}>{"Activate Auto Booking"}</h4>
        <ExpressFleetSwitch
          id="enableToggle"
          name="enabled"
          checked={enabled}
          onClick={() => setEnabled(!enabled)}
          courierChoices={courierChoices}
        />
      </div>

      <StatusMinutesField
        autoBookingConfig={config}
        setConfig={setConfig}
        disabledField={disabledField}
        errors={errors}
        resetFormErrors={resetFormErrors}
        courierChoices={courierChoices}
      />
    </>
  );
};

AutoBookingDialogForm.displayName = "AutoBookingDialogForm";
export default AutoBookingDialogForm;
